import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { createTranslator, getLocale, setLocale } from './index';

const LanguageContext = createContext({
  t: (k) => k,
  lang: 'en-US',
  setLang: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getLocale());
  const [tFunc, setTFunc] = useState(() => (k) => k);

  useEffect(() => {
    let active = true;
    createTranslator(lang).then(({ t }) => {
      if (!active) return;
      setTFunc(() => t);
    });
    return () => {
      active = false;
    };
  }, [lang]);

  const value = useMemo(
    () => ({
      t: tFunc,
      lang,
      setLang: (next) => {
        setLocale(next);
        setLangState(next);
      },
    }),
    [tFunc, lang]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
